import { Check } from 'lucide-react';
import { FOCUS_ATTR } from './constantes';

export interface ItemReste { cle: string; ok: boolean; txt: string }

/** « Il reste à faire » : ce qui est fait et ce qui manque ; chaque ligne amène au bon champ. */
export function ResteAFaire({ items, onAller }: { items: ItemReste[]; onAller: (cle: string) => void }) {
  return (
    <nav className="nd-reste" aria-label="Il reste à faire">
      <div className="nd-micro">Il reste à faire</div>
      <ul>
        {items.map((i) => (
          <li key={i.cle}>
            <button type="button" className={`nd-reste-it${i.ok ? ' is-ok' : ''}`} {...{ [FOCUS_ATTR]: `r${i.cle}` }} onClick={() => onAller(i.cle)}>
              <span className="nd-rond" aria-hidden="true">{i.ok && <Check size={11} />}</span>
              <span>{i.txt}</span>
              <span className="nd-sr">{i.ok ? ' (fait)' : ' (à faire)'}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
